import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import * as globalAdd from '../../connectionString';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { WebUserDetails } from '../../shared/models/WebUserDetails';
import { WebUserService } from '../services/WebUser.service';
import { map } from 'rxjs/operators';


@Injectable()
export class AuthServiceService {
  CurrentUser: WebUserDetails;
  AllUsers: WebUserDetails[];
  constructor(private http: HttpClient, private router: Router, private webServ: WebUserService) {

    this.AllUsers = JSON.parse(localStorage.getItem('userDetails'));
    if (this.AllUsers != undefined && this.AllUsers != null) {
      this.CurrentUser = this.AllUsers.filter(i => i.id == this.webServ.getUserId())[0];
    }
  }

  userAuthentication(username, password,panelType) {
    var data = "username=" + username + "&password=" +encodeURIComponent(password) + "&grant_type=password";
    //application/x-www-urlencodedEncodeURIcomponent
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.http.post(globalAdd.Paneladdress + 'token?panelType='+ panelType+'', data, { headers: reqHeader });
  }

  testingApiData() {
    var reqHeader = new HttpHeaders({  'No-Auth': 'True' });
    return this.http.post(globalAdd.Paneladdress + 'api/My/Testing/getMyData',{text:JSON.stringify({id:"123",name:"bla"})},{headers:reqHeader});

  }


  RefreshToken(){
    var data = "refresh_token=" + localStorage.getItem('refreshToken') + "&grant_type=refresh_token";
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.http.post(globalAdd.Paneladdress + 'token', data, { headers: reqHeader }).pipe(map((AllData) => {
      this.CurrentUser.userToken = AllData["access_token"];
      this.CurrentUser.userRole = AllData['role'];
      this.CurrentUser.refreshToken = AllData['refresh_token'];
      this.AllUsers[this.AllUsers.findIndex(i => i.id == JSON.parse(sessionStorage.getItem('Id')))] = this.CurrentUser;
      localStorage.setItem('userDetails', JSON.stringify(this.AllUsers));
    }));
  }

  selectionDb(Db: string) {
    return this.http.post(globalAdd.Paneladdress + 'api/dashboard/selectDb', { Db: Db }, { headers: new HttpHeaders({ 'No-Auth': 'True' }) });
  }

  getPermissionsData() {
    return this.http.get(globalAdd.Paneladdress + 'api/Doctor/getPermissionsIntoSession');
  }

  roleMatch(allowedRole: Array<string>): boolean {
    //console.log(JSON.parse(sessionStorage.getItem('Id')));
    this.AllUsers = JSON.parse(localStorage.getItem('userDetails'));
    if (this.AllUsers != undefined && this.AllUsers != null) {
      this.CurrentUser = this.AllUsers.filter(i => i.id == JSON.parse(sessionStorage.getItem('Id')))[0];
    }
    var isMatch = false;
    var userRole:string = null;
    if (this.CurrentUser != null && this.CurrentUser != undefined) {
     userRole = this.CurrentUser.userRole;
    }
    if (userRole != undefined && userRole != null) {
      if (allowedRole.indexOf(userRole) > -1) {
        isMatch = true;
      }
    }
    else {
      isMatch = false;
    }
    return isMatch;
  }

  //refreshAccessToken(){
  //  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
  //  var data = "refresh_token=" + localStorage.getItem("refreshToken") + "&grant_type=refresh_token";
  ////  req = new HttpRequest("POST", globalAdd.Paneladdress + 'token', data, { headers: reqHeader });


  //  this.http.post(globalAdd.Paneladdress + 'token', data, { headers: reqHeader }).subscribe((data3) => {
  //    var AllData = Object.assign(Array(), data3["body"]);

  //    localStorage.setItem('userToken', AllData.access_token);
  //    localStorage.setItem('userRole', AllData.role);
  //    localStorage.setItem('refreshToken', AllData.refresh_token);

  //  });}
  
 
}

